import { DatePickerView } from '@mui/lab/DatePicker/shared';

export enum ChoiceDateBoolean {
  active = '1',
  notActive = '0',
}

export enum FormatoData {
  Completa = 1,
  SenzaGiorno = 2,
  SenzaGiornoMese = 3,
  Eta = 4,
}

// Valore sentinel usato come "view" del radio "Età": non è una DatePickerView reale,
// serve solo a selezionare il radio e a mostrare il campo Età al posto del DatePicker.
export const ETA_VIEW = 'eta' as DatePickerView;

export const etaChoice: Array<DatePickerView> = [ETA_VIEW];

export const defaultChoicePickerState: Array<DatePickerView> = ['day', 'month', 'year'];
